import { useEffect } from "react"
import { useTagManager } from "@xingternal/winery-tag-manager"
import { getCurrentUser } from "@/services/api"

export const useWineryTagManager = (options = {}) => {
  const env = window.environment !== "production" ? "preview" : "production"
  const { initializeTagManagerOnce, isTagManagerInitiated } = useTagManager({
    env,
  })

  const getUserHashedEmail = async () => {
    try {
      if (!isTagManagerInitiated) {
        const { data } = await getCurrentUser()
        initializeTagManagerOnce({
          bid: data.currentUser.hashedEmail,
          options: options,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getUserHashedEmail()
  }, [getUserHashedEmail, initializeTagManagerOnce])
}
